import { createStyles, makeStyles, Theme } from '../styles/styles';

type StatusVariant = 'success' | 'error';

const statusBackgroundColor = (theme: Theme, variant: StatusVariant) => {
  if (variant === 'success') {
      return theme.color.greens[10];
  }
  return theme.color.reds[10];
}

const statusDotColor = (theme: Theme, variant: StatusVariant) => {
  if (variant === 'success') {
      return theme.color.greens[100];
  }
  return theme.color.reds[100];
}

export default makeStyles((theme: Theme) => createStyles({
  status: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  statusInner: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    backgroundColor: ({ variant }: { variant: StatusVariant }) => statusBackgroundColor(theme, variant),
    padding: '2px 8px',
    borderRadius: 4,
  },
  statusDot: {
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'transparent',
  },
  statusDotIcon: {
    width: 6,
    height: 6,
    display: 'block',
    borderRadius: '50%',
    backgroundColor: ({ variant }: { variant: StatusVariant }) => statusDotColor(theme, variant),
  },
}), { name: 'Status' });
